import React from "react";

import { Icon } from "semantic-ui-react";

import "./ToastNotification.css";
import { useTranslation } from "react-i18next";


const ToastNotification = (props) => {
    const { t } = useTranslation()
    return (
        <div className="barestho-toast-notification">
            <Icon name={props.iconName} size="large" />{t(props.message)}
        </div>
    )

}


export default ToastNotification;


// WEBPACK FOOTER //
// ./src/components/ToastNotification/ToastNotification.js